<template>
<div class="chapter">
<div class="inner_page">
<p class="block_" id="id_start" xml:lang="en"> </p>
<p class="block_1" xml:lang="en">Le Roi Gros Bédonnant</p>
<p class="block_2"> </p>
<p class="block_3" xml:lang="en">pedro marangoni</p>
<p class="block_" xml:lang="en"> </p>
<p class="block_2"> </p>
<p class="block_2"> </p>
<p class="block_4" xml:lang="en">Traduit par Isadora Fouraux et William Sessa </p>
<p class="block_" xml:lang="en"> </p>
<p class="block_5"><span class="text_" xml:lang="en"><br class="calibre4" id="calibre_pb_0"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?4fab2bd0